import { AxiosRequestConfig } from "axios";
import { httpTokenCommon, httpEmployeeDiscount } from "../helper/http-common";
import {
  BikeDiscountAdminDashboardFilters,
  BikeDiscountErrorLogFilters,
  BikeDiscountCitiesResponse,
  BikeDiscountDealersByCityResponse,
  BikeDiscountModelsResponse,
  BikeDiscountSubmitPayload,
  BikeDiscountApiFailureEmailPayload,
  BikeDiscountApprovalDetailsResponse,
  BikeDiscountApprovalActionRequest,
  BikeDiscountApprovalActionResponse,
} from "../types/bikeDiscount";

class BikeDiscountService {
  getEmployeeById(config?: AxiosRequestConfig) {
    return httpTokenCommon.get("BikeDiscount/getEmployeeById", config);
  }

  getDealers() {
    return httpTokenCommon.get("BikeDiscount/getDealers");
  }

  getModels(dealerCode: string) {
    return httpTokenCommon.get("BikeDiscount/getModels", {
      params: { dealerCode },
    });
  }

  submitBikeDiscount(payload: BikeDiscountSubmitPayload) {
    return httpTokenCommon.post("BikeDiscount/submit", payload, {
      skipErrorToast: true,
    });
  }

  sendApiFailureEmail(payload: BikeDiscountApiFailureEmailPayload) {
    return httpTokenCommon.post("BikeDiscount/sendApiFailureEmail", payload, {
      skipErrorToast: true,
    });
  }

  getApplicationDashboard(payload: BikeDiscountAdminDashboardFilters) {
    return httpTokenCommon.post(
      "BikeDiscount/admin/GetApplicationDashboard",
      payload
    );
  }

  getAdminErrorLog(payload: BikeDiscountErrorLogFilters) {
    return httpTokenCommon.post(
      "BikeDiscount/GetBikeDiscountAdminErrorLog",
      payload
    );
  }

  // Employee Discount (ADF) APIs
  getCities(config?: AxiosRequestConfig) {
    return httpEmployeeDiscount.get<BikeDiscountCitiesResponse>(
      "cities",
      config
    );
  }

  getDealersByCity(city: string, config?: AxiosRequestConfig) {
    return httpEmployeeDiscount.get<BikeDiscountDealersByCityResponse>(
      `dealers/${encodeURIComponent(city)}`,
      config
    );
  }

  getModelCodes(config?: AxiosRequestConfig) {
    return httpEmployeeDiscount.get<BikeDiscountModelsResponse>(
      "models",
      config
    );
  }

  // Public approval link APIs
  getBikeDiscountApprovalDetails(token: string) {
    return httpTokenCommon.get<BikeDiscountApprovalDetailsResponse>(
      "bike-discount/approval-details",
      { params: { token } }
    );
  }

  submitBikeDiscountApprovalAction(payload: BikeDiscountApprovalActionRequest) {
    return httpTokenCommon.post<BikeDiscountApprovalActionResponse>(
      "bike-discount/approval-action",
      payload
    );
  }
}

const bikeDiscountService = new BikeDiscountService();
export default bikeDiscountService;
